import { render, staticRenderFns } from "./SectionSlider.vue?vue&type=template&id=28caec80&scoped=true&"
import script from "./SectionSlider.vue?vue&type=script&lang=js&"
export * from "./SectionSlider.vue?vue&type=script&lang=js&"
import style0 from "./SectionSlider.vue?vue&type=style&index=0&id=28caec80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28caec80",
  null
  
)

export default component.exports